// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Berkshire+Swash&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.cdnfonts.com/css/sansation);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* header.css */


header {
  background-color: #f8f9fa; /* Light background color */
  padding: 10px 30px; /* Adjust padding to reduce height */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Optional shadow for depth */
  margin-bottom:40px;
}

nav {
  display: flex; /* Use Flexbox */
  justify-content: space-between; /* Space out left and right */
  align-items: center; /* Center items vertically */
  flex-wrap: nowrap; /* Prevent wrapping */
}

.left {
  display: flex; /* Use Flexbox for left items */
  align-items: center; /* Center vertically */
}

.left h1 {
  margin: 0; /* Remove default margin */
  font-size: 32px; /* Increase font size for a larger header */
}

.right {
  display: flex; /* Use Flexbox for right items */
  align-items: center; /* Center list items vertically */
}

.right ul {
  list-style: none; /* Remove bullet points */
  margin: 0; /* Remove default margin */
  padding: 0; /* Remove default padding */
  display: flex; /* Use Flexbox for list items */
  align-items: center; /* Center list items vertically */
}

.right li {
  margin-left: 20px; /* Space between list items */
  position: relative; /* Position for dropdown */
}

.right img {
  margin-left: 10px; /* Add some space to the image */
  vertical-align: middle; /* Align the image with text */
  cursor: pointer; /* Change cursor to pointer */
}

.right a {
  text-decoration: none; /* Remove underline from links */
  color: #333; /* Text color */
}

.right a:hover {
  text-decoration: underline; /* Add underline on hover for links */
}

.logo-link {
  text-decoration: none; /* Remove underline */
  color: inherit; /* Use the same text color as the surrounding text */
}

.logo-link:hover {
  cursor: pointer; /* Change cursor to pointer when hovered */
}

/* Dropdown styles */
.dropdown {
  position: absolute; /* Position the dropdown */
  top: 70px; /* Position below the image */
  right: 0; /* Align to the right */
  background-color: white; /* White background for dropdown */
  border: 1px solid #ddd; /* Border around dropdown */
  border-radius: 4px; /* Slight rounding of corners */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); /* Shadow for depth */
  z-index: 10; /* Ensure dropdown is above other elements */
  display: flex; /* Use Flexbox */
  flex-direction: column; /* Stack dropdown items vertically */
  width: 100%; /* Full width for dropdown */
  max-width: 150px; /* Limit the max width to avoid overflow */
  overflow: hidden; /* Hide overflow if any */
}

.dropdown li {
  padding: 10px 15px; /* Spacing for dropdown items */
  white-space: nowrap; /* Prevent text wrapping */
}

.dropdown li:hover {
  background-color: #f1f1f1; /* Change background on hover */
}

/* Responsive styles */
@media (max-width: 768px) {
  nav {
      flex-direction: row; /* Keep items in a row */
      justify-content: space-between; /* Space out left and right */
  }

  .left {
      margin-right: auto; /* Ensure logo is on the left */
  }

  .right {
      margin-left: auto; /* Ensure profile is on the right */
  }

  .right ul {
      flex-direction: row; /* Keep list items in a row */
      align-items: center; /* Align items vertically */
  }

  .right li {
      margin-left: 10px; /* Adjust spacing for mobile */
  }

  .dropdown {
      width: auto; /* Set to auto to avoid cutting off */
      max-width: 80vw; /* Use a percentage width for better visibility */
      right: 0; /* Align dropdown to the right */
      z-index: 20; /* Ensure it is above other elements */
      top: 75px; /* Adjust position slightly to avoid overlap */
  }
}



/* Increase dropdown size for PC only */
@media (min-width: 1024px) { /* Adjust breakpoint as needed */
  .dropdown {
      max-width: 200px; /* Increased size for desktop */
      width: auto; /* Adjust to avoid stretching */
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/header.css"],"names":[],"mappings":"AAAA,eAAe;;;AAKf;EACE,yBAAyB,EAAE,2BAA2B;EACtD,kBAAkB,EAAE,oCAAoC;EACxD,wCAAwC,EAAE,8BAA8B;EACxE,kBAAkB;AACpB;;AAEA;EACE,aAAa,EAAE,gBAAgB;EAC/B,8BAA8B,EAAE,6BAA6B;EAC7D,mBAAmB,EAAE,4BAA4B;EACjD,iBAAiB,EAAE,qBAAqB;AAC1C;;AAEA;EACE,aAAa,EAAE,+BAA+B;EAC9C,mBAAmB,EAAE,sBAAsB;AAC7C;;AAEA;EACE,SAAS,EAAE,0BAA0B;EACrC,eAAe,EAAE,2CAA2C;AAC9D;;AAEA;EACE,aAAa,EAAE,gCAAgC;EAC/C,mBAAmB,EAAE,iCAAiC;AACxD;;AAEA;EACE,gBAAgB,EAAE,yBAAyB;EAC3C,SAAS,EAAE,0BAA0B;EACrC,UAAU,EAAE,2BAA2B;EACvC,aAAa,EAAE,+BAA+B;EAC9C,mBAAmB,EAAE,iCAAiC;AACxD;;AAEA;EACE,iBAAiB,EAAE,6BAA6B;EAChD,kBAAkB,EAAE,0BAA0B;AAChD;;AAEA;EACE,iBAAiB,EAAE,gCAAgC;EACnD,sBAAsB,EAAE,8BAA8B;EACtD,eAAe,EAAE,6BAA6B;AAChD;;AAEA;EACE,qBAAqB,EAAE,gCAAgC;EACvD,WAAW,EAAE,eAAe;AAC9B;;AAEA;EACE,0BAA0B,EAAE,qCAAqC;AACnE;;AAEA;EACE,qBAAqB,EAAE,qBAAqB;EAC5C,cAAc,EAAE,oDAAoD;AACtE;;AAEA;EACE,eAAe,EAAE,0CAA0C;AAC7D;;AAEA,oBAAoB;AACpB;EACE,kBAAkB,EAAE,0BAA0B;EAC9C,SAAS,EAAE,6BAA6B;EACxC,QAAQ,EAAE,uBAAuB;EACjC,uBAAuB,EAAE,kCAAkC;EAC3D,sBAAsB,EAAE,2BAA2B;EACnD,kBAAkB,EAAE,+BAA+B;EACnD,wCAAwC,EAAE,qBAAqB;EAC/D,WAAW,EAAE,4CAA4C;EACzD,aAAa,EAAE,gBAAgB;EAC/B,sBAAsB,EAAE,oCAAoC;EAC5D,WAAW,EAAE,4BAA4B;EACzC,gBAAgB,EAAE,0CAA0C;EAC5D,gBAAgB,EAAE,yBAAyB;AAC7C;;AAEA;EACE,kBAAkB,EAAE,+BAA+B;EACnD,mBAAmB,EAAE,0BAA0B;AACjD;;AAEA;EACE,yBAAyB,EAAE,+BAA+B;AAC5D;;AAEA,sBAAsB;AACtB;EACE;MACI,mBAAmB,EAAE,wBAAwB;MAC7C,8BAA8B,EAAE,6BAA6B;EACjE;;EAEA;MACI,kBAAkB,EAAE,+BAA+B;EACvD;;EAEA;MACI,iBAAiB,EAAE,mCAAmC;EAC1D;;EAEA;MACI,mBAAmB,EAAE,6BAA6B;MAClD,mBAAmB,EAAE,2BAA2B;EACpD;;EAEA;MACI,iBAAiB,EAAE,8BAA8B;EACrD;;EAEA;MACI,WAAW,EAAE,qCAAqC;MAClD,eAAe,EAAE,iDAAiD;MAClE,QAAQ,EAAE,gCAAgC;MAC1C,WAAW,EAAE,sCAAsC;MACnD,SAAS,EAAE,8CAA8C;EAC7D;AACF;;;;AAIA,uCAAuC;AACvC,6BAA6B,gCAAgC;EAC3D;MACI,gBAAgB,EAAE,+BAA+B;MACjD,WAAW,EAAE,+BAA+B;EAChD;AACF","sourcesContent":["/* header.css */\r\n@import url('https://fonts.googleapis.com/css2?family=Berkshire+Swash&display=swap');\r\n@import url('https://fonts.cdnfonts.com/css/sansation');\r\n\r\n\r\nheader {\r\n  background-color: #f8f9fa; /* Light background color */\r\n  padding: 10px 30px; /* Adjust padding to reduce height */\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Optional shadow for depth */\r\n  margin-bottom:40px;\r\n}\r\n\r\nnav {\r\n  display: flex; /* Use Flexbox */\r\n  justify-content: space-between; /* Space out left and right */\r\n  align-items: center; /* Center items vertically */\r\n  flex-wrap: nowrap; /* Prevent wrapping */\r\n}\r\n\r\n.left {\r\n  display: flex; /* Use Flexbox for left items */\r\n  align-items: center; /* Center vertically */\r\n}\r\n\r\n.left h1 {\r\n  margin: 0; /* Remove default margin */\r\n  font-size: 32px; /* Increase font size for a larger header */\r\n}\r\n\r\n.right {\r\n  display: flex; /* Use Flexbox for right items */\r\n  align-items: center; /* Center list items vertically */\r\n}\r\n\r\n.right ul {\r\n  list-style: none; /* Remove bullet points */\r\n  margin: 0; /* Remove default margin */\r\n  padding: 0; /* Remove default padding */\r\n  display: flex; /* Use Flexbox for list items */\r\n  align-items: center; /* Center list items vertically */\r\n}\r\n\r\n.right li {\r\n  margin-left: 20px; /* Space between list items */\r\n  position: relative; /* Position for dropdown */\r\n}\r\n\r\n.right img {\r\n  margin-left: 10px; /* Add some space to the image */\r\n  vertical-align: middle; /* Align the image with text */\r\n  cursor: pointer; /* Change cursor to pointer */\r\n}\r\n\r\n.right a {\r\n  text-decoration: none; /* Remove underline from links */\r\n  color: #333; /* Text color */\r\n}\r\n\r\n.right a:hover {\r\n  text-decoration: underline; /* Add underline on hover for links */\r\n}\r\n\r\n.logo-link {\r\n  text-decoration: none; /* Remove underline */\r\n  color: inherit; /* Use the same text color as the surrounding text */\r\n}\r\n\r\n.logo-link:hover {\r\n  cursor: pointer; /* Change cursor to pointer when hovered */\r\n}\r\n\r\n/* Dropdown styles */\r\n.dropdown {\r\n  position: absolute; /* Position the dropdown */\r\n  top: 70px; /* Position below the image */\r\n  right: 0; /* Align to the right */\r\n  background-color: white; /* White background for dropdown */\r\n  border: 1px solid #ddd; /* Border around dropdown */\r\n  border-radius: 4px; /* Slight rounding of corners */\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); /* Shadow for depth */\r\n  z-index: 10; /* Ensure dropdown is above other elements */\r\n  display: flex; /* Use Flexbox */\r\n  flex-direction: column; /* Stack dropdown items vertically */\r\n  width: 100%; /* Full width for dropdown */\r\n  max-width: 150px; /* Limit the max width to avoid overflow */\r\n  overflow: hidden; /* Hide overflow if any */\r\n}\r\n\r\n.dropdown li {\r\n  padding: 10px 15px; /* Spacing for dropdown items */\r\n  white-space: nowrap; /* Prevent text wrapping */\r\n}\r\n\r\n.dropdown li:hover {\r\n  background-color: #f1f1f1; /* Change background on hover */\r\n}\r\n\r\n/* Responsive styles */\r\n@media (max-width: 768px) {\r\n  nav {\r\n      flex-direction: row; /* Keep items in a row */\r\n      justify-content: space-between; /* Space out left and right */\r\n  }\r\n\r\n  .left {\r\n      margin-right: auto; /* Ensure logo is on the left */\r\n  }\r\n\r\n  .right {\r\n      margin-left: auto; /* Ensure profile is on the right */\r\n  }\r\n\r\n  .right ul {\r\n      flex-direction: row; /* Keep list items in a row */\r\n      align-items: center; /* Align items vertically */\r\n  }\r\n\r\n  .right li {\r\n      margin-left: 10px; /* Adjust spacing for mobile */\r\n  }\r\n\r\n  .dropdown {\r\n      width: auto; /* Set to auto to avoid cutting off */\r\n      max-width: 80vw; /* Use a percentage width for better visibility */\r\n      right: 0; /* Align dropdown to the right */\r\n      z-index: 20; /* Ensure it is above other elements */\r\n      top: 75px; /* Adjust position slightly to avoid overlap */\r\n  }\r\n}\r\n\r\n\r\n\r\n/* Increase dropdown size for PC only */\r\n@media (min-width: 1024px) { /* Adjust breakpoint as needed */\r\n  .dropdown {\r\n      max-width: 200px; /* Increased size for desktop */\r\n      width: auto; /* Adjust to avoid stretching */\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
